// Состояние обновления веб-слоя (Zustand, app.md §4).
//
// Отдельный стор, а не часть useUiStore: у обновления свой жизненный цикл (проверка →
// загрузка → готово), и оно переживает переходы между экранами — проверка стартует
// один раз на монтировании защищённого слоя, а баннер виден на любом экране.
//
// Что сюда НЕ кладут: манифест с сервера (это разовый ответ, не состояние) и id
// скачанного бандла держим здесь только потому, что он нужен кнопке «Обновить».

import { create } from 'zustand';

/**
 * - `idle` — проверок не было или новее ничего нет;
 * - `checking` — идёт запрос манифеста;
 * - `downloading` — бандл качается;
 * - `ready` — бандл скачан и проверен, ждёт нажатия «Обновить»;
 * - `applying` — пользователь нажал, webview вот-вот перезагрузится;
 * - `error` — проверка или загрузка сорвались; молча, повтор на следующей проверке.
 */
export type AppUpdatePhase = 'idle' | 'checking' | 'downloading' | 'ready' | 'applying' | 'error';

type AppUpdateState = {
  readonly phase: AppUpdatePhase;
  /** Версия готового к применению бандла — показывается в баннере. */
  readonly readyVersion: string | null;
  /** id бандла в плагине — нужен только кнопке «Обновить». */
  readonly bundleId: string | null;
  readonly setPhase: (phase: AppUpdatePhase) => void;
  readonly setReady: (args: { version: string; bundleId: string }) => void;
  readonly reset: () => void;
};

export const useAppUpdateStore = create<AppUpdateState>()((set) => ({
  phase: 'idle',
  readyVersion: null,
  bundleId: null,
  setPhase: (phase) => set({ phase }),
  setReady: ({ version, bundleId }) => set({ phase: 'ready', readyVersion: version, bundleId }),
  reset: () => set({ phase: 'idle', readyVersion: null, bundleId: null }),
}));
